import { useMutation, useQuery } from 'react-query';
import axiosInstance from '@api/axiosInstance';

export const fetchFn = async (method, url, param) => {
  switch (method.toLowerCase()) {
    case 'get':
      return await axiosInstance.get(url, { params: param });
    case 'post':
      return await axiosInstance.post(url, param);
    case 'put':
      return await axiosInstance.put(url, param);
    case 'delete':
      return await axiosInstance.delete(url, param);
    default:
      throw new Error(`no fetch method : ${method}, url: ${url}, param: ${param}`);
  }
};

const useFetch = (key, method, url, param, option) => {
  const query = useQuery(key, () => fetchFn(method, url, param), {
    ...option,
  });

  return query;
};

export const useFetchMute = (method, url, param, option) => {
  return useMutation(() => fetchFn(method, url, param), { ...option });
};

export const useFetchMuteParam = (method, url, option) => {
  return useMutation((param) => fetchFn(method, url, param), { ...option });
};

export default useFetch;
